/**
 * Persistencia de filtros de listas: se limpia al login
 * para que aplique el filtro por defecto del usuario.
 */

export const FILTRO_STORAGE_KEYS = {
  feedPrefix: 'sigefi.feed.filtros.',
  recurrentesPrefix: 'sigefi.recurrentes.filtros.',
  movimientosList: 'sigefi.movimientos-list'
} as const;

/** Limpia snapshots de filtros del usuario (local + session). */
export function clearFiltrosPersistidos(userId?: number | null): void {
  try {
    if (userId != null) {
      localStorage.removeItem(`${FILTRO_STORAGE_KEYS.feedPrefix}${userId}`);
      localStorage.removeItem(`${FILTRO_STORAGE_KEYS.recurrentesPrefix}${userId}`);
    } else {
      // Limpiar todas las claves de prefijo conocidas
      for (let i = localStorage.length - 1; i >= 0; i--) {
        const k = localStorage.key(i);
        if (!k) continue;
        if (
          k.startsWith(FILTRO_STORAGE_KEYS.feedPrefix) ||
          k.startsWith(FILTRO_STORAGE_KEYS.recurrentesPrefix)
        ) {
          localStorage.removeItem(k);
        }
      }
    }
  } catch {
    // ignore
  }
  try {
    sessionStorage.removeItem(FILTRO_STORAGE_KEYS.movimientosList);
  } catch {
    // ignore
  }
}
